export default __webpack_public_path__ + "static/media/BlackCurtain6.1e0c5d01.png";